// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".root__R22FLjfF{display:flex;flex-direction:column;height:100%;position:relative}.root__R22FLjfF .segment-legend-header__XeRzbf8Z{margin:0}.root__R22FLjfF .line-chart__WZzeHIRx{display:block;flex:1;min-height:0}.root__R22FLjfF .mp-spinner__D3L0EYG3{height:40px;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:40px}.root__R22FLjfF .mp-context-menu__ULIfOIet{position:absolute;z-index:7000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "root__R22FLjfF",
	"segmentLegendHeader": "segment-legend-header__XeRzbf8Z",
	"lineChart": "line-chart__WZzeHIRx",
	"mpSpinner": "mp-spinner__D3L0EYG3",
	"mpContextMenu": "mp-context-menu__ULIfOIet"
};

/*** EXPORTS FROM exports-loader ***/
export default ___CSS_LOADER_EXPORT___.toString();
